import { ButtonSkeleton } from "@/components/Loaders/Skeleton/Skeleton";
import { Spinner } from "@/components/Loaders/Spinner/Spinner";
import React from "react";

interface ButtonWrapperProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  loading?: boolean;
}
export const ButtonWrapper = ({
  children,
  disabled,
  loading,
  ...props
}: ButtonWrapperProps) => {
  const isDisabled = disabled || loading;
  return (
    <button
      {...props}
      disabled={isDisabled}
      className={
        (isDisabled ? " opacity-50" : "") +
        " bg-linear-120 from-dark-pink to-dark-teal " +
        props.className
      }
    >
      {loading ? <ButtonSkeleton>{children}</ButtonSkeleton> : children}
    </button>
  );
};
